import React from 'react';
import Page from 'src/components/Page';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PurchaseForm from './PurchaseForm';

const useStyles = makeStyles(theme => {
  return {
    root: {
      paddingTop: theme.spacing(3),
    },
  };
});

const Purchase = () => {
  const classes = useStyles();
  return (
    <Page>
      <Container maxWidth={false} className={classes.root}>
        <PurchaseForm />
      </Container>
    </Page>
  );
};

export default Purchase;
